import { AlertReason } from "../models/entities/alert.model";
import { UseMyAlertsResult, useMyAlerts } from "./useMyAlerts";

/**
 * The logged-in user's unresolved "Appointment cancelled" alerts (task rule KAN-2667,
 * reason "Appointment cancelled"), for the Home worklist (KAN-2671).
 *
 * Reads the SAME `/api/tasks/` rows as Requires attention and critical alerts,
 * so a resolve from any surface refreshes this hook's shared query keys; it is
 * assignee == me unconditionally.
 *
 * Kept as its own module so tests can mock it independently.
 */
export const useMyAppointmentCancelledAlerts = (
	assigneeId: number | undefined | null
): UseMyAlertsResult => useMyAlerts(assigneeId, AlertReason.APPOINTMENT_CANCELLED);
